import { prop } from "ramda";
import { createSelector } from "reselect";
import { SHOW_IDENTIFIER } from "./constants";

const sidebarSelector = (state: any) => state.sidebar;

export const selectShowSidebar: any = createSelector(
  sidebarSelector,
  prop(SHOW_IDENTIFIER)
);
